import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { isAuthenticated } from '../helpers/adminApi'

function PrivateRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated()
          ? <Component {...props} />
          : <Redirect to="/admin" />
      }
    />
  )
}

export default PrivateRoute
